// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-white {
  /*    border: 2px solid #00C1D4;*/
  border: 2px solid #FF6423;
}

.action_download_box {
  text-align: center;
  justify-content: center;
  margin-bottom: 2rem;
}

.full-width {
  width: 100%;
}

.horizontalLine {
  width: 100%;
  height: 1px;
  margin: 10px 0;
}

.checkboxTitle {
  font-weight: 500;
  padding-bottom: 5px;
}

::ng-deep .row15Padding mat-form-field {
  width: 100%;
}
::ng-deep .actionStyle mat-icon-button {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.mat-white {
  /*    border: 2px solid #00C1D4; old colour*/
  border: 2px solid #FF6423;
}

@media only screen and (max-width: 599px) {
  .padding15Right {
    padding: 0;
  }
  form > div {
    display: block !important;
  }
  form > div > div.checkbox {
    display: inline-grid !important;
  }
}
.marginLeft15 {
  margin-left: 15px;
}

.actionStyle {
  margin: auto;
  display: block;
  margin-bottom: 10px;
  text-align: center;
}

.autoFeeCode {
  font-size: 16px;
  margin: 10px 0;
}

.autoFeeCode mat-icon.mat-icon.notranslate.material-icons.mat-icon-no-color {
  font-size: 14px;
  height: 0px;
  width: 10px;
  cursor: pointer;
}

.border-box {
  border: 1px solid;
  padding: 6px;
  border-radius: 5px;
  /*    border-color: #00C1D4; old colour*/
  border-color: #00C1D4;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-dialog-data/custom-dialog-data.component.scss"],"names":[],"mappings":"AAAA;EACA,iCAAA;EACI,yBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAGI;EACI,WAAA;AAAR;AAEI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAAR;;AAIA;EACA,4CAAA;EACI,yBAAA;AADJ;;AAIA;EACI;IACI,UAAA;EADN;EAGE;IACI,yBAAA;EADN;EAGE;IACI,+BAAA;EADN;AACF;AAIA;EACI,iBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,cAAA;AAFJ;;AAKA;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;EACJ,wCAAA;EACI,qBAAA;AAFJ","sourcesContent":[".mat-white {\n/*    border: 2px solid #00C1D4;*/\n    border: 2px solid #FF6423;\n}\n\n.action_download_box {\n    text-align: center;\n    justify-content: center;\n    margin-bottom: 2rem;\n}\n\n.full-width {\n    width: 100%;\n}\n\n.horizontalLine {\n    width: 100%;\n    height: 1px;\n    margin: 10px 0;\n}\n\n.checkboxTitle {\n    font-weight: 500;\n    padding-bottom: 5px;\n}\n\n ::ng-deep {\n    .row15Padding mat-form-field {\n        width: 100%;\n    }\n    .actionStyle mat-icon-button {\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n    }\n}\n\n.mat-white {\n/*    border: 2px solid #00C1D4; old colour*/\n    border: 2px solid #FF6423;\n}\n\n@media only screen and (max-width: 599px) {\n    .padding15Right {\n        padding: 0;\n    }\n    form>div {\n        display: block!important;\n    }\n    form>div>div.checkbox {\n        display: inline-grid!important;\n    }\n}\n\n.marginLeft15 {\n    margin-left: 15px;\n}\n\n.actionStyle {\n    margin: auto;\n    display: block;\n    margin-bottom: 10px;\n    text-align: center;\n}\n\n.autoFeeCode {\n    font-size: 16px;\n    margin: 10px 0;\n}\n\n.autoFeeCode mat-icon.mat-icon.notranslate.material-icons.mat-icon-no-color {\n    font-size: 14px;\n    height: 0px;\n    width: 10px;\n    cursor: pointer;\n}\n\n.border-box {\n    border: 1px solid;\n    padding: 6px;\n    border-radius: 5px;\n/*    border-color: #00C1D4; old colour*/\n    border-color: #00C1D4;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
